import React, {useEffect, useLayoutEffect} from "react";
import {Link, useLocation} from "react-router-dom";
import Helmet from "react-helmet";
import logo from "../assets/ETC-Base_Logo.svg";

const scrollPageToTop = () => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
};

const kvkkEmail = "etcbase_kvkk_komite@etcbase.com";

const renderParagraph = (paragraph, labeled) => {
    if (labeled) {
        const splitAt = paragraph.indexOf(":");
        if (splitAt > 0) {
            return (
                <>
                    <strong>{paragraph.slice(0, splitAt + 1)}</strong>
                    {paragraph.slice(splitAt + 1)}
                </>
            );
        }
    }
    if (!paragraph.includes(kvkkEmail)) {
        return paragraph;
    }
    const [before, after] = paragraph.split(kvkkEmail);
    return (
        <>
            {before}
            <a href={"mailto:" + kvkkEmail}>{kvkkEmail}</a>
            {after}
        </>
    );
};

const LegalPoliciesPage = ({title, documentTitle, updated, sections, formHref, formLabel, compactTitle}) => {
    const {pathname} = useLocation();

    useLayoutEffect(() => {
        if ("scrollRestoration" in window.history) {
            window.history.scrollRestoration = "manual";
        }
        scrollPageToTop();
        const frame = requestAnimationFrame(scrollPageToTop);
        return () => cancelAnimationFrame(frame);
    }, [pathname]);

    useEffect(() => {
        const timer = window.setTimeout(scrollPageToTop, 0);
        return () => window.clearTimeout(timer);
    }, [pathname]);

    return (
        <>
            <Helmet>
                <title>{documentTitle || title}</title>
            </Helmet>
            <div className="legal-back-bar">
                <div className="legal-back-inner">
                    <Link className="legal-logo-link" to="/subscription" onClick={scrollPageToTop}>
                        <img className="legal-logo" src={logo} alt="etcBASE"/>
                    </Link>
                    <button type="button" className="legal-back" onClick={() => window.history.back()}>
                        Geri Dön
                    </button>
                </div>
            </div>
        <main className="legal-page">
            <h1 className={compactTitle ? "legal-title-compact" : undefined}>{title}</h1>
            {updated ? <p className="legal-updated">{updated}</p> : null}
            {(() => {
                let subNumber = 0;
                return sections.map((section) => {
                if (section.main) {
                    subNumber = 0;
                } else if (section.sub && section.heading) {
                    subNumber += 1;
                }
                const heading = section.sub ? subNumber + ". " + section.heading : section.heading;
                return (
                <section key={section.heading || section.paragraphs[0]}>
                    {section.heading
                        ? (section.main
                            ? <h2 className="legal-main-heading">{heading}</h2>
                            : (section.sub ? <h3>{heading}</h3> : <h2>{heading}</h2>))
                        : null}
                    {(section.paragraphs || []).map((paragraph) => (
                        <p className={section.labeled ? "legal-label-line" : undefined} key={paragraph}>{renderParagraph(paragraph, section.labeled)}</p>
                    ))}
                    {section.items ? (
                        <ul className={section.boldItems ? "legal-strong-list" : undefined}>
                            {section.items.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    ) : null}
                </section>
                );
                });
            })()}
            {formHref ? (
                <p className="legal-form-link">
                    <a href={formHref} target="_blank" rel="noreferrer"><strong>{formLabel}</strong></a>
                </p>
            ) : null}
        </main>
        </>
    );
};

export default LegalPoliciesPage;
